export const ROW_HEIGHT = 50;
export const ROW_GAP = 12;
export const COLS_AMOUNT = 3;
export const ORDER_WIDTH_SMALL = 220;
